import { observer } from 'mobx-react-lite'
import { type ScopeChangeRequestsViewModel } from '@/features/admin/scope-change-requests/ScopeChangeRequestsViewModel'
import { ScopeChangeRequestTable } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestTable'
import { ScopeChangeRequestRowContainer } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestRow/ScopeChangeRequestRowContainer'
import { InfiniteScrollLoaderContainer } from '@/components/InfiniteScrollLoader/InfiniteScrollLoaderContainer'

export interface ScopeChangeRequestTableContainerProps {
  vm: ScopeChangeRequestsViewModel
}

export const ScopeChangeRequestTableContainer = observer(
  function ScopeChangeRequestTableContainer({
    vm,
  }: ScopeChangeRequestTableContainerProps) {
    return (
      <ScopeChangeRequestTable
        columns={vm.columns.map((col) => ({
          id: col.id,
          header: col.header,
          canSort: col.sortable,
          sortOrder: vm.getSortOrder(col),
          onSort: (newSort) => vm.setSortOrder(col, newSort),
        }))}
        loader={
          <InfiniteScrollLoaderContainer
            scrollProvider={vm.searcher.scroller}
          />
        }
      >
        {vm.items.map((itemVm) => (
          <ScopeChangeRequestRowContainer
            key={itemVm.scopeChangeRequest.id}
            vm={itemVm}
            columnIds={vm.columnIds}
          />
        ))}
      </ScopeChangeRequestTable>
    )
  },
)
